import * as React from 'react';
import { LineModel, CartPart, CUT_OUT_TYPES, CartModel, PartModel, getPartDetail } from 'franke-trough-dependencies';
import { FormattedNumber, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { requestAPIActions } from 'loopback-react-request';
import { CutOutLabel } from '../../Inputs/Recesses/CutOutDisposalSelection';
import MESSAGES from './CheckoutParts.messages';

export interface PartListItemPartialProps {
  dispatch: any;
  clientInfo: GlobalPrivateState['clientInfo'];
  configuration: GlobalPrivateState['configuration'];
  checkout: GlobalPrivateState['checkout'];
  lineItem: LineModel; 
  part: PartModel;
  userData: GlobalPrivateState['userData'];
}

export interface PartListItemState {
  qty: string;
  qtyInitial: string;
}

interface PartRespond {
  qty: number;
  id: string;
}

export class PartListItemPartial extends React.Component<PartListItemPartialProps, PartListItemState> {
  constructor(props: PartListItemPartialProps) {
    super(props);

    this.state = {
      qty: props.lineItem.qty.toString(),
      qtyInitial: props.lineItem.qty.toString()
    };

    this.handleQtyChange = this.handleQtyChange.bind(this);
  }

  public render() {
    const part = this.props.part;
    const lang: any = this.props.userData && this.props.userData.result && this.props.userData.result.lang && this.props.userData.result.lang.split('-')[0] || 'en';
    // const disabled = ((this.checkout && this.props.checkout.updating) || (!isConfigurationEditable()));

    return (
      <div className="trough-partial-line">
        <div className="row align-items-top">
          <div className="col-9">
            <span className="configuration-name">
              {part.key === 'cut_out_part' ? (
                <CutOutLabel value={part.partId as CUT_OUT_TYPES} text={true} />
              ) : (
                <>
                  {getPartDetail(part.id.toLocaleLowerCase(), 'name', lang)}
                </>
              )}
            </span>
          </div>
          {
              /*<div className="col-2">
            <div className="form-group mb-0">
              <DebounceInput
                disabled={disabled}
                className="form-control text-right item-quantity" 
                type="number"
                value={this.state.qty}
                min={this.state.qtyInitial}
                onChange={this.handleQtyChange}
                debounceTimeout={500}
              />
            </div>
          </div>*/
              }
          <div className="col-3 text-right">
            <span className="price">
              {this.state.qty}x&nbsp;
              <FormattedNumber
                value={this.props.lineItem.part.price} 
                currency={this.checkout && this.checkout.currency || 'EUR'}
                currencyDisplay="code"
                style="currency"
              />
            </span>
          </div>
        </div>
        <div className="trough-partial-line">
          <ul>
            {getPartDetail(part.id.toLocaleLowerCase(), 'article', lang) !== part.id && (
              <li className="mb-3">
                <strong>
                  <FormattedMessage {...MESSAGES.articleNumber} />: {getPartDetail(part.id.toLocaleLowerCase(), 'article', lang)}
                </strong>
              </li>
            )}
            <li dangerouslySetInnerHTML={{__html: getPartDetail(part.id.toLocaleLowerCase(), 'description', lang, true) }}></li>
          </ul>
        </div>
      </div>
    );
  }

  private get checkout(): CartModel |undefined {
    const { checkout } = this.props;
    return checkout && checkout.result;
  }

  private handleQtyChange(ev: React.SyntheticEvent<HTMLInputElement>) {
    const target = ev.target as HTMLInputElement;
    const value = target.value;
    const state: PartListItemState = this.state;

    // If qty has changed, and greater than initial amount or it's empty, then set state
    if (state.qty !== value && (Number(value) >= Number(state.qtyInitial) || value === '')) {
      state.qty = value;
      this.setState(state);

      // Only if it's greater than initial amount should
      if (value !== '') {
        const configurationId = this.props.configuration.result && this.props.configuration.result.id;
  
        // Have to get checkout parts and merge with new qty... 
        const lineParts = this.checkout && this.checkout.lines && this.checkout.lines.parts;
        const qtys: PartRespond[] = [];
  
        // TODO - Maybe don't get it from checkout state... feels dirty...
        if (lineParts) {
          const thisPart = this.props.part as CartPart;
  
          for (let linePart of lineParts) {
            const part = linePart.part as CartPart;
  
            if (part.id === thisPart.id) {
              linePart.qty = Number(this.state.qty);
            }
            
            if (part.id) {
              qtys.push({qty: linePart.qty, id: part.id || ''});
            }
          }
        }
        
        this.props.dispatch(requestAPIActions.load(
          'checkout', {
            url: `/Configurations/${configurationId}/checkout`,
            options: {
              method: 'POST',
              data: qtys
            }
          },
          true
        ));
      }
    }
  }
}

export const PartListItem = connect((state: GlobalPrivateState) => ({
  clientInfo: state.clientInfo,
  configuration: state.configuration,
  checkout: state.checkout,
  userData: state.userData
}))(PartListItemPartial);

export default PartListItem;